const { userRoles } = storeToRefs(useUserStore())

export default defineNuxtRouteMiddleware(async () => {
  if (!userRoles.value.includes('teacher')) {
    return navigateTo('/')
  }
})
